/* ICH BIN CHRIST – Shop-Verhalten.
   Warenkorb-Drawer über die Shopify Ajax Cart API (cart.js, cart/add.js,
   cart/change.js), Bild-Toggle, Reveal-Animationen und die Umschaltung
   zwischen Newsletter und Passwort-Eingabe auf der Passwortseite. */
(function () {
  "use strict";

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  /* Preise im Warenkorb so formatieren, wie der Shop es eingestellt hat
     (Shopify-Admin -> Einstellungen -> Allgemein -> Währungsformat). Das
     Format steht als Attribut am Drawer, damit hier nichts fest verdrahtet
     ist – ein Shop in Franken oder Dollar sieht sonst falsch aus. */
  var MONEY_FORMAT = (document.getElementById("cart-drawer") || {}).dataset
    ? document.getElementById("cart-drawer").dataset.moneyFormat || "{{amount_with_comma_separator}} €"
    : "{{amount_with_comma_separator}} €";

  function gruppiere(zahl, tausender, dezimal, stellen) {
    var teile = (cents_zu_zahl(zahl, stellen)).split(".");
    var ganz = teile[0].replace(/\B(?=(\d{3})+(?!\d))/g, tausender);
    return stellen > 0 && teile[1] ? ganz + dezimal + teile[1] : ganz;
  }

  function cents_zu_zahl(cents, stellen) {
    return (cents / 100).toFixed(stellen);
  }

  var formatMoney = function (cents) {
    return MONEY_FORMAT.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, name) {
      switch (name) {
        case "amount_no_decimals":                      return gruppiere(cents, ",", ".", 0);
        case "amount_with_comma_separator":             return gruppiere(cents, ".", ",", 2);
        case "amount_no_decimals_with_comma_separator": return gruppiere(cents, ".", ",", 0);
        case "amount_with_apostrophe_separator":        return gruppiere(cents, "'", ".", 2);
        default:                                        return gruppiere(cents, ",", ".", 2);
      }
    });
  };

  var toggle = function (node, show) { if (node) node.hidden = !show; };

  /* Alle sichtbaren Texte kommen aus den Theme-Einstellungen und hängen als
     Attribute am Warenkorb-Drawer. So muss niemand ins Skript, um ein Wort
     zu ändern. */
  var text = function (name) {
    var drawer = document.getElementById("cart-drawer");
    return (drawer && drawer.dataset[name]) || "";
  };

  var el = {
    badge: $("#cart-badge"),
    buyBtn: $("#buy-btn"),
    sizes: $("#product-sizes"),
    price: $("#drop-price"),
    priceNow: $("#drop-price-now"),
    priceOld: $("#drop-price-old"),
    cartOverlay: $("#cart-overlay"),
    cartDrawer: $("#cart-drawer"),
    cartEmpty: $("#cart-empty"),
    cartBody: $("#cart-body"),
    cartItems: $("#cart-items"),
    cartSubtotal: $("#cart-subtotal"),
    tplCartItem: $("#tpl-cart-item")
  };

  var cartOpen = false;
  var lastCart = null;

  /* ----------------------------------------------------------- Warenkorb */

  function request(path, body) {
    var options = { headers: { "Accept": "application/json" } };
    if (body) {
      options.method = "POST";
      options.headers["Content-Type"] = "application/json";
      options.body = JSON.stringify(body);
    }
    return fetch(ROOT + path, options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) throw data;
        return data;
      });
    });
  }

  function renderCart(cart) {
    lastCart = cart;

    if (el.badge) {
      el.badge.textContent = cart.item_count;
      toggle(el.badge, cart.item_count > 0);
    }
    if (!el.cartItems || !el.tplCartItem) return;

    var empty = cart.items.length === 0;
    toggle(el.cartEmpty, empty);
    toggle(el.cartBody, !empty);

    var frag = document.createDocumentFragment();
    cart.items.forEach(function (item) {
      var node = el.tplCartItem.content.firstElementChild.cloneNode(true);
      node.dataset.key = item.key;
      $(".cart-item__name", node).textContent = item.product_title;
      $(".cart-item__size", node).textContent =
        item.variant_title && !item.product_has_only_default_variant ? text("sizePrefix") + item.variant_title : "";
      $(".cart-item__count", node).textContent = item.quantity;
      $(".cart-item__line", node).textContent = formatMoney(item.final_line_price);
      if (item.image) $(".cart-item__thumb", node).style.backgroundImage = 'url("' + item.image + '")';
      frag.appendChild(node);
    });
    el.cartItems.replaceChildren(frag);
    el.cartSubtotal.textContent = formatMoney(cart.items_subtotal_price);
  }

  function refreshCart() {
    return request("cart.js").then(renderCart).catch(function () {});
  }

  function setDrawer(open) {
    cartOpen = open;
    toggle(el.cartOverlay, open);
    toggle(el.cartDrawer, open);
  }

  function addToCart(variantId) {
    return request("cart/add.js", { items: [{ id: Number(variantId), quantity: 1 }] })
      .then(refreshCart)
      .then(function () { setDrawer(true); })
      .catch(function (err) {
        alert((err && err.description) || text("cartError"));
      });
  }

  function changeQty(key, quantity) {
    return request("cart/change.js", { id: key, quantity: Math.max(0, quantity) })
      .then(renderCart)
      .catch(function () {});
  }

  function qtyOf(key) {
    if (!lastCart) return 0;
    var item = lastCart.items.filter(function (i) { return i.key === key; })[0];
    return item ? item.quantity : 0;
  }

  /* -------------------------------------------------------------- Events */

  function onClick(event) {
    var target = event.target.closest("[data-action]");
    if (!target) return;

    switch (target.dataset.action) {
      case "open-cart":
        refreshCart();
        setDrawer(true);
        break;

      case "close-cart":
        setDrawer(false);
        break;

      case "checkout":
        window.location.href = ROOT + "checkout";
        break;

      /* Größenwahl auf der Drop-Seite: merkt die Variante am Kauf-Button,
         zeigt deren Preis an und schaltet den Button frei. */
      case "select-size": {
        if (!el.sizes || !el.buyBtn) break;
        $$(".size-btn", el.sizes).forEach(function (b) {
          b.classList.toggle("size-btn--active", b === target);
        });
        el.buyBtn.dataset.variantId = target.dataset.variantId;
        el.buyBtn.classList.add("is-visible");
        /* Preis und Streichpreis gehören zusammen: Gibt es für die gewählte
           Größe keinen Vergleichspreis, verschwindet die durchgestrichene
           Zahl – sonst stünde dort der Preis einer anderen Größe. */
        if (el.priceNow && target.dataset.price) el.priceNow.textContent = target.dataset.price;
        if (el.priceOld) {
          var vergleich = target.dataset.compare;
          el.priceOld.textContent = vergleich || "";
          el.priceOld.hidden = !vergleich;
          if (el.price) el.price.classList.toggle("is-reduziert", !!vergleich);
        }
        break;
      }

      case "add-to-cart": {
        var id = target.dataset.variantId || (el.buyBtn && el.buyBtn.dataset.variantId);
        if (id) addToCart(id);
        break;
      }

      case "toggle-image":
        if (target.querySelector(".media-img--back")) target.classList.toggle("show-back");
        break;

      case "qty-inc": {
        var incKey = target.closest(".cart-item").dataset.key;
        changeQty(incKey, qtyOf(incKey) + 1);
        break;
      }

      case "qty-dec": {
        var decKey = target.closest(".cart-item").dataset.key;
        changeQty(decKey, qtyOf(decKey) - 1);
        break;
      }

      case "remove-item": {
        var remKey = target.closest(".cart-item").dataset.key;
        changeQty(remKey, 0);
        break;
      }

      case "show-password-view":
        toggle($("#pw-view-main"), false);
        toggle($("#pw-view-entry"), true);
        break;

      case "show-newsletter-view":
        toggle($("#pw-view-entry"), false);
        toggle($("#pw-view-main"), true);
        break;
    }
  }

  function init() {
    document.addEventListener("click", onClick);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && cartOpen) setDrawer(false);
    });

    var reveals = $$(".reveal");
    if (reveals.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) entry.target.classList.add("is-visible");
        });
      }, { threshold: .25 });
      reveals.forEach(function (n) { observer.observe(n); });
    }

    if ($("[data-pw-error]")) {
      toggle($("#pw-view-main"), false);
      toggle($("#pw-view-entry"), true);
    }

    refreshCart();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
